import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { SelectionPage } from 'app/BCKSPage/SelectionPage'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsSelectionPage {
  isKSSelectionEnabled: boolean
  isKSSeleksiTertutupEnabled: boolean
}

export async function getServerSideProps() {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')
  const isKSSeleksiTertutupEnabled = await isToggleEnabled(
    'ks-selection-seleksi-tertutup-enabled'
  )

  return {
    props: {
      isKSSelectionEnabled,
      isKSSeleksiTertutupEnabled,
    },
  }
}

const SelectionPageIndex = (props: PropsSelectionPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return (
    <SelectionPage
      isKSSeleksiTertutupEnabled={props.isKSSeleksiTertutupEnabled}
    />
  )
}

// eslint-disable-next-line react/display-name
SelectionPageIndex.Layout = ({ children }) => children

export default SelectionPageIndex
